/**
 * Pure filter/match helpers for `OutreachPlatformField`. Kept out of the
 * `.tsx` file so the component module stays component-only (Fast Refresh
 * rule — see apps/web/CLAUDE.md § Conventions).
 */

/** Case-insensitive substring match on `query` against `options`. An empty/whitespace query returns every option. */
export function filterOutreachPlatformOptions(
  options: readonly string[],
  query: string,
): readonly string[] {
  const q = query.trim().toLowerCase();
  if (q.length === 0) return options;
  return options.filter((o) => o.toLowerCase().includes(q));
}

/** Does `query` case-insensitively exact-match one of `options`? */
export function isExactOutreachPlatformMatch(
  options: readonly string[],
  query: string,
): boolean {
  return findExactOutreachPlatformMatch(options, query) !== undefined;
}

/**
 * The option `query` case-insensitively exact-matches, in its catalog
 * casing (e.g. query "instantly" -> "Instantly"), or `undefined` if none
 * matches. Used by Enter-to-commit so a case-insensitive typed match commits
 * the catalog's canonical spelling rather than whatever case the user typed.
 */
export function findExactOutreachPlatformMatch(
  options: readonly string[],
  query: string,
): string | undefined {
  const q = query.trim().toLowerCase();
  if (q.length === 0) return undefined;
  return options.find((o) => o.toLowerCase() === q);
}
